// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"SapoyRSzHGANG26DyIGN","triggerElement":"SIvUdfCXx3ABLxrBVcnx"};